import base from '../../base';
import { CUSTOMER } from '../../../constraints';

export default {
  ...base,
  backendUrl: 'https://apiedupublication.trusted-document.com',
  customer: CUSTOMER.DIPLOMA,
  enablePrivate: true,
};
